import {
  ApiResponse,
  SearchApi,
  SearchOrganisationRequest,
  SolrOrganisationReduced,
  SolrResultSolrOrganisationReduced,
} from '../../api/core';
import { getAuthMiddleware } from '../../Auth/utils/GetAuthMiddleware';
import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { AuthContext } from '../../Auth/components/AuthProvider';
import SearchResults, { ExternalSearchResultProps } from './SearchResults';
import { organisationsDefaultSort } from '../../Settings/config';
import { FormattedMessage } from 'react-intl';
import { SearchResultOrganisation } from './components/SearchResultOrganisation';
import { organisationFacetsSettings } from '../../Settings/search/organisation-facets';
import { organisationsSortOptions } from '../../Settings/data';
import { useLocation } from 'react-router';

export function SearchResultsOrganisation(props: ExternalSearchResultProps): ReactNode {
  const {actions} = useContext(AuthContext);
  const api: SearchApi = new SearchApi().withMiddleware(getAuthMiddleware(actions));
  const location = useLocation();

  const renderResult = (result: SolrOrganisationReduced, index: number): ReactNode =>
    <SearchResultOrganisation key={index} position={index+1} result={result} redirectPath={location.pathname} />;

  return <SearchResults
    searchFunction={async (requestParameters: SearchOrganisationRequest): Promise<SolrResultSolrOrganisationReduced | null> => {
      const results: ApiResponse<SolrResultSolrOrganisationReduced> = await api.searchOrganisationRaw(requestParameters);
      if (!results.raw.status) {
        return null;
      }
      return await results.value();
    }}
    externalParams={props.externalParams}
    defaultSortOption={organisationsDefaultSort}
    facetSettings={organisationFacetsSettings}
    title={<FormattedMessage id="search.organisation.banner.subtitle"/>}
    sortOptions={organisationsSortOptions}
    renderResult={renderResult}
    path={'/search/organisations'}
    headerImage={require('../../Settings/img/banners/search/organisation.svg')}
  />;
}

export default SearchResultsOrganisation;
